import { Triangle } from 'fabric';

const makeArrowHead = (
  left: number,
  top: number,
  angle: number,
  scaleFactor?: number,
): Triangle =>
  new Triangle({
    left,
    top,
    angle,
    scaleX: scaleFactor || 1,
    scaleY: scaleFactor || 1,
    originX: 'center',
    originY: 'center',
    hasBorders: false,
    hasControls: false,
    selectable: false,
    lockScalingX: true,
    lockScalingY: true,
    lockRotation: true,
    name: 'arrowHead',
    width: 10,
    height: 10,
    fill: '#fff',
    excludeFromExport: false,
  });

export default makeArrowHead;
